import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import AttachmentLink from '../../../Shared/AttachmentLink';
import AttachmentLinksList from '../../../Shared/AttachmentLinksList';
import PostLocation from '../../../Shared/PostLocation';
import ReadMore from '../../../../ReadMore/ReadMore';
import { moment } from '../../../../../I18n';

interface AnswerShowProps {
  answer: any;
  showPreview?: boolean;
  geojson?: string | null;
}

export default function AnswerShow({ answer, showPreview, geojson }: AnswerShowProps) {
  const intl = useIntl();

  if (!answer) {
    return null;
  }

  const { lat, lng } = answer;

  if (answer?.question_options?.length > 0) {
    return (
      <Stack
        direction="row"
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        {answer.question_options.map((qo: any) => {
          return (
            <Chip
              key={qo.id}
              label={
                <Typography variant="body2" style={{ whiteSpace: 'normal' }}>
                  {qo.other ? answer.content_i18n : qo.label}
                </Typography>
              }
              size="small"
              variant="outlined"
              sx={{ backgroundColor: 'white', height: '100%' }}
            />
          );
        })}
      </Stack>
    );
  }

  if (!!lat && !!lng) {
    return <PostLocation label={answer?.content} lat={lat} lng={lng} geojson={geojson} />;
  }

  if (answer?.date) {
    return moment(answer.date).format(intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' }));
  }

  if (answer?.content || answer?.content_i18n) {
    return <ReadMore content={answer.content || answer.content_i18n} />;
  }

  if (answer?.attachments?.length > 0) {
    if (showPreview) {
      return <AttachmentLinksList attachments={answer.attachments} />;
    }

    return (
      <Box role="list">
        {answer.attachments.map((attachment: any) => (
          <Box
            key={attachment.url}
            role="listitem"
            sx={{
              my: 1,
            }}
          >
            <AttachmentLink attachment={attachment} size="small" />
          </Box>
        ))}
      </Box>
    );
  }

  return null;
}
